import { IApiEntitySmpAgTag } from "@smp/api";
import { UiBox, UiSkeleton } from "@smp/ui";

import { PaletteItem } from "./palette_item";

export const ColorPalette = ({
  tags,
  backUrl,
}: {
  tags?: IApiEntitySmpAgTag[];
  backUrl: string;
}) => (
  <UiBox display="flex" mb={2}>
    {!tags ? (
      <>
        {[...Array(4)].map((_, idx) => (
          <UiSkeleton
            key={idx}
            variant="card"
            width={24}
            height={24}
            m={[0, 1, 0, 0]}
          />
        ))}
      </>
    ) : (
      tags?.map((tag) => (
        <PaletteItem key={tag.slug} colorTag={tag} backUrl={backUrl} />
      ))
    )}
  </UiBox>
);
